var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drop-down-box"},_vm._l((this.menuItems),function(menu,index){return _c('div',{key:index,staticClass:"menu-items-wrap"},[_c('div',{on:{"click":_vm.hideMenu}},[_c('a',{class:[
          'menu-item',
          { 'a-exact-active': _vm.activeCondition.indexOf(menu.name) > -1 }
        ],attrs:{"href":`${menu.direction}`}},[_vm._v(" "+_vm._s(menu.title))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }